import { AbsenceTypeName } from "~/modules/absence/api/absence/absenceTypes.ts";
import type {
	TimeTrackingBarThemes,
} from "~/modules/timeTracking/components/components/Day/components/TimeTrackingBar/timeTrackingBarVariants.ts";

/** The classes of one type color. Each class is a full string, so that Tailwind finds it. */
export type EntryColor = {
	/** The background of a dot or a stripe. */
	solid: string;
	/** The text color. */
	text: string;
	/** The light tint of an absence row. */
	tint: string;
	/** The ring of an open absence row. */
	ring: string;
};

const accent600: EntryColor = { solid: "bg-accent-600", text: "text-accent-600", tint: "bg-accent-600/10", ring: "ring-accent-600" };
const red500: EntryColor = { solid: "bg-red-500", text: "text-red-500", tint: "bg-red-500/10", ring: "ring-red-500" };
const primary300: EntryColor = { solid: "bg-primary-300", text: "text-primary-300", tint: "bg-primary-300/10", ring: "ring-primary-300" };
const accent500: EntryColor = { solid: "bg-accent-500", text: "text-accent-500", tint: "bg-accent-500/10", ring: "ring-accent-500" };

const trackingColors: Record<TimeTrackingBarThemes, EntryColor> = {
	project: { solid: "bg-primary-400", text: "text-gray-800", tint: "bg-primary-400/10", ring: "ring-primary-400" },
	projectNotBillable: { solid: "bg-[#c00000]", text: "text-[#c00000]", tint: "bg-[#c00000]/10", ring: "ring-[#c00000]" },
	internal: { solid: "bg-gray-400", text: "text-gray-800", tint: "bg-gray-400/10", ring: "ring-gray-400" },
	sales: { solid: "bg-gray-600", text: "text-gray-800", tint: "bg-gray-600/10", ring: "ring-gray-600" },
	partTime: { solid: "bg-success-dark-700", text: "text-gray-800", tint: "bg-success-dark-700/10", ring: "ring-success-dark-700" },
	absence: accent600,
	default: { solid: "bg-gray-300", text: "text-gray-800", tint: "bg-gray-300/10", ring: "ring-gray-300" },
};

const absenceColors: Partial<Record<string, EntryColor>> = {
	[AbsenceTypeName.Vacation]: accent600,
	[AbsenceTypeName.Sick]: red500,
	[AbsenceTypeName.Sabbatical]: primary300,
	[AbsenceTypeName.MaternityLeave]: primary300,
	[AbsenceTypeName.ParentalLeave]: primary300,
	[AbsenceTypeName.Training]: accent500,
	[AbsenceTypeName.InternalEvent]: accent500,
	[AbsenceTypeName.Special]: accent500,
};

export function getTrackingColor(theme: TimeTrackingBarThemes): EntryColor {
	return trackingColors[theme];
}

export function getAbsenceColor(absenceName: string): EntryColor {
	return absenceColors[absenceName] ?? accent600;
}

/** Below `md` the card buttons are bigger, so a finger hits them. */
export const phoneButtonClass = "max-md:h-10 max-md:px-4 max-md:text-sm";
